import { requests } from './agent'
import { HttpResponse } from '../models/http/Reponse'
import { Log } from '../models/Log'

interface LostListResponse extends HttpResponse {
  data: Log[]
}

const Logs = {
  allLogs: () => requests.get<LostListResponse>('Logs'),
}

export default Logs
